import { useState } from "react";
import SelectButton from "./SelectButton";

## Basic Usage

export function BasicSelectButton() {
  const [selected, setSelected] = useState("");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      <SelectButton value="option1" selected={selected === "option1"} onSelection={setSelected}>
        Option 1
      </SelectButton>
      <SelectButton value="option2" selected={selected === "option2"} onSelection={setSelected}>
        Option 2
      </SelectButton>
      <SelectButton value="option3" selected={selected === "option3"} onSelection={setSelected}>
        Option 3
      </SelectButton>
      <p>Selected: **{selected || "none"}**</p>
    </div>
  );
}

<BasicSelectButton />

---

## Selection Group

export function SelectionGroup() {
  const [selected, setSelected] = useState("monthly");
  const options = [
    { value: "monthly", label: "Monthly billing" },
    { value: "annual", label: "Annual billing (save 20%)" },
    { value: "lifetime", label: "Lifetime access" },
  ];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", maxWidth: "300px" }}>
      {options.map((opt) => (
        <SelectButton key={opt.value} value={opt.value} selected={selected === opt.value} onSelection={setSelected}>
          {opt.label}
        </SelectButton>
      ))}
    </div>
  );
}

<SelectionGroup />

---

## Horizontal Layout

export function HorizontalLayout() {
  const [selected, setSelected] = useState("sm");
  const sizes = [
    { value: "xs", label: "XS" },
    { value: "sm", label: "S" },
    { value: "md", label: "M" },
    { value: "lg", label: "L" },
    { value: "xl", label: "XL" },
  ];
  return (
    <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
      {sizes.map((size) => (
        <SelectButton key={size.value} value={size.value} selected={selected === size.value} onSelection={setSelected}>
          {size.label}
        </SelectButton>
      ))}
    </div>
  );
}

<HorizontalLayout />

---

## Pre-selected State

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <SelectButton value="selected" selected onSelection={() => {}}>
    Selected option
  </SelectButton>
  <SelectButton value="unselected" selected={false} onSelection={() => {}}>
    Unselected option
  </SelectButton>
</div>


